module.exports = __webpack_public_path__ + "img/AC_S6_Header.bca81026.jpg";